module.exports = __webpack_public_path__ + "img/img005.296df793.png";